import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from '../../common/BaseComponent/BaseComponent';


import styles from './RemovePromoCodeMessage.scss';

import CloseButton from "../../common/primitives/CloseButton";
import Button from "../../common/primitives/Button";
import buttons from "../../common/primitives/Button.scss";


import {notify} from "../../common/primitives/Notification/Notification";
import LoadingRow from "../../common/primitives/LoadingRow";
import {ContextDataStore} from "../../common/helpers/HelperGlobalDataStore";
import {__t} from '../../common/lang/text-resource';

class RemovePromoCodeMessage extends BaseComponent {
	constructor(props) {
		super(props);
		this.state = {
			loadingPromoCodeRemove: false,
		};

		this.removePromoCode = this.removePromoCode.bind(this);

		this.close = this.close.bind(this);
	}

	close() {
		this.state.isVisible = false;
		this.setState(this.state);
	}

	eventConsume(eventName, eventData) {
		if (eventName === 'ShowRemovePopupMessage') {
			const {popupName} = eventData;
			if (popupName === this.props.name) {
				this.state.isVisible = true;
				this.setState(this.state);
			}
		}
	}

	removePromoCode() {
		this.setState({loadingPromoCodeRemove: true}, () => {
			this.props.removePromoCode(() => {
				this.setState({loadingPromoCodeRemove: false});
				notify.success(this.messages.PROMO_CODE_REMOVED_SUCCESS);
			});
		});
	}

	render() {
		let isVisible = this.state.isVisible;

		document.body.style.overflow = "auto";
		if (isVisible) {
			document.body.style.overflow = "hidden"
		}

		if (!isVisible) {
			return null;
		}

		return (
		  <div className={styles.container}>
			  <div>
				  <div className={styles.closeButton}>
					  <CloseButton onClick={this.close} altText={"Close"}/>
				  </div>
				  <div className={styles.content} data-layout='margin-top--lg'>
					  <h1>{__t('Промоционален код')}</h1>
					  <div data-layout="margin-top--md">
						  {__t('към-вашата-поръчка-е-приложен-промо-код-promoCoded11405', {promoCode: this.props.promoCode})}
						  <br/>
						  <br/>
						  <div data-layout="row start center gutter-none">
							  <div data-layout="col 12 text-center">
								  {
									  (this.state.loadingPromoCodeRemove) ?
										<div className={styles.loadingContainer}>
											<LoadingRow/>
										</div>
										:

										<div>
											<Button
											  onClick={this.removePromoCode}
											  name={'do_remove_promo_code'}
											  value={__t('Изтриване на промокод')}/>
											<br/>
											<Button
											  onClick={this.close}
											  name={'closePromoCodePopup'}
											  value={__t('Връщане към поръчка')}
											  className={`${buttons.buttonLink} ${styles.textButton}`}
											/>
										</div>

								  }
							  </div>
						  </div>
					  </div>
				  </div>
			  </div>
		  </div>
		)
	}
}

RemovePromoCodeMessage.propTypes = {
	name: PropTypes.string.isRequired,
	isVisible: PropTypes.bool.isRequired,
	removePromoCode: PropTypes.func,
};


// React Context binding
RemovePromoCodeMessage.contextType = ContextDataStore;

export default RemovePromoCodeMessage;